import type { OpeningHour, Salon } from "./types";
import { ratingFor, reviewCountFor, salonReviewStats } from "./reviewStats";
import ahlensUtsida from "@/assets/opt/ahlens-utsida.webp";
import tabyUtanfor from "@/assets/opt/taby-utanfor.webp";
import akersbergaEntre from "@/assets/opt/akersberga-entre.webp";
import arningeUtanfor from "@/assets/opt/arninge-utanfor.webp";
import ahlensUtsidaThumb from "@/assets/opt/thumb/ahlens-utsida.webp";
import tabyUtanforThumb from "@/assets/opt/thumb/taby-utanfor.webp";
import akersbergaEntreThumb from "@/assets/opt/thumb/akersberga-entre.webp";
import arningeUtanforThumb from "@/assets/opt/thumb/arninge-utanfor.webp";
const ahlens = ahlensUtsida;
const taby = tabyUtanfor;
const akersberga = akersbergaEntre;
const arninge = arningeUtanfor;
const ahlensThumb = ahlensUtsidaThumb;
const tabyThumb = tabyUtanforThumb;
const akersbergaThumb = akersbergaEntreThumb;
const arningeThumb = arningeUtanforThumb;


const ahlensHours: OpeningHour[] = [
  { day: "Mån", hours: "10:00–20:00" },
  { day: "Tis", hours: "10:00–20:00" },
  { day: "Ons", hours: "10:00–20:00" },
  { day: "Tor", hours: "10:00–20:00" },
  { day: "Fre", hours: "10:00–20:00" },
  { day: "Lör", hours: "10:00–19:00" },
  { day: "Sön", hours: "11:00–19:00" },
];

const tabyHours: OpeningHour[] = [
  { day: "Mån", hours: "10:00–20:00" },
  { day: "Tis", hours: "10:00–20:00" },
  { day: "Ons", hours: "10:00–20:00" },
  { day: "Tor", hours: "10:00–20:00" },
  { day: "Fre", hours: "10:00–20:00" },
  { day: "Lör", hours: "10:00–18:00" },
  { day: "Sön", hours: "10:00–18:00" },
];

const akersbergaHours: OpeningHour[] = [
  { day: "Mån", hours: "10:00–19:00" },
  { day: "Tis", hours: "10:00–19:00" },
  { day: "Ons", hours: "10:00–19:00" },
  { day: "Tor", hours: "10:00–19:00" },
  { day: "Fre", hours: "10:00–19:00" },
  { day: "Lör", hours: "10:00–18:00" },
  { day: "Sön", hours: "10:00–18:00" },
];

const arningeHours: OpeningHour[] = [
  { day: "Mån", hours: "10:00–19:00" },
  { day: "Tis", hours: "10:00–19:00" },
  { day: "Ons", hours: "10:00–19:00" },
  { day: "Tor", hours: "10:00–19:00" },
  { day: "Fre", hours: "10:00–19:00" },
  { day: "Lör", hours: "10:00–18:00" },
  { day: "Sön", hours: "10:00–18:00" },
];

export const salons: Salon[] = [
  {
    slug: "taby",
    name: "Tailor's Barber Täby Centrum",
    shortName: "Täby Centrum",
    url: "/barberare-stockholm-taby",
    bokaDirektUrl: "https://www.bokadirekt.se/places/tailors-barber-taby-centrum-37677",
    phone: "+468371156",
    phoneDisplay: "08-371 156",
    email: "info@tailorsbarber.com",
    address: "Biblioteksgången 1",
    postal: "183 34",
    city: "Täby",
    mapsUrl: "https://www.google.com/maps/place/Tailor%27s+Barber+T%C3%A4by+Centrum/@59.444582,18.0729985,17z/data=!3m1!4b1!4m6!3m5!1s0x465f9b3df21b2ea7:0x33a9b508a251e296!8m2!3d59.444582!4d18.0729985!16s%2Fg%2F11gj74kjkx",
    lat: 59.4441,
    lng: 18.0707,
    description:
      "Vår flaggskeppssalong i Westfield Täby Centrum — Tailor's Barbers mest bokade salong med Stockholmsregionens mest erfarna barberare.",
    image: taby,
    imageThumb: tabyThumb,
    // Omdömestal: se src/data/reviewStats.ts (enda källan).
    rating: ratingFor("taby"),
    reviewCount: reviewCountFor("taby"),
    googleRating: salonReviewStats["taby"].google.rating,
    googleReviewCount: salonReviewStats["taby"].google.count,
    openingHours: tabyHours,
    servicesOffered: ["herrklippning", "har-skagg", "taper-fade", "fade", "barnklippning", "drop-in"],
    priceRange: "$$",
    featuredLabel: "Täby",
    featured: true,
  },
  {
    slug: "ahlens-city",
    name: "Tailor's Barber Åhléns City",
    shortName: "Åhléns City",
    url: "/barberare-stockholm-ahlens-city",
    bokaDirektUrl: "https://www.bokadirekt.se/places/tailors-barber-stockholm-ahlens-city-37678",
    phone: "+468371156",
    phoneDisplay: "08-371 156",
    email: "info@tailorsbarber.com",
    address: "Klarabergsgatan 50",
    postal: "111 21",
    city: "Stockholm",
    mapsUrl: "https://www.google.com/maps/place/Tailor%27s+Barber+-+Barber+Stockholm+City+%C3%85hl%C3%A9ns/@59.3323261,18.0616898,17z/data=!3m1!4b1!4m6!3m5!1s0x465f9dddc9e1e3f5:0x580c52bedc1c25b6!8m2!3d59.3323261!4d18.0616898!16s%2Fg%2F11fwz3lr81",
    lat: 59.3325,
    lng: 18.0593,
    description:
      "Vår salong inne i Stockholm City. Centralt belägen i Åhléns på Klarabergsgatan — Stockholms mest lättillgängliga barbershop för dig som jobbar eller shoppar i city.",
    image: ahlens,
    imageThumb: ahlensThumb,
    // Omdömestal: se src/data/reviewStats.ts (enda källan).
    rating: ratingFor("ahlens-city"),
    reviewCount: reviewCountFor("ahlens-city"),
    googleRating: salonReviewStats["ahlens-city"].google.rating,
    googleReviewCount: salonReviewStats["ahlens-city"].google.count,
    openingHours: ahlensHours,
    servicesOffered: ["herrklippning", "har-skagg", "taper-fade", "fade", "barnklippning", "drop-in"],
    priceRange: "$$",
    featuredLabel: "Stockholm",
  },
  {
    slug: "akersberga",
    name: "Tailor's Barber Åkersberga",
    shortName: "Åkersberga Ica Maxi",
    url: "/barberare-stockholm-akersberga",
    bokaDirektUrl: "https://www.bokadirekt.se/places/tailors-barber-akersberga-ica-maxi-huset--37682",
    phone: "+468371156",
    phoneDisplay: "08-371 156",
    email: "info@tailorsbarber.com",
    address: "Långhundravägen 9",
    postal: "184 44",
    city: "Åkersberga",
    mapsUrl: "https://www.google.com/maps/place/Tailors+Barber+%C3%85kersberga/@59.4893121,18.2660818,17z/data=!3m1!4b1!4m6!3m5!1s0x465f8f87acb673f7:0x3eec64b33a92e1d!8m2!3d59.4893122!4d18.2709527!16s%2Fg%2F11stsvd38r",
    lat: 59.4791,
    lng: 18.2961,
    description:
      "Vår lokala salong i ICA Maxi Åkersberga. En personlig miljö med yrkesskickliga barberare och drop-in i mån av plats.",
    image: akersberga,
    imageThumb: akersbergaThumb,
    // Omdömestal: se src/data/reviewStats.ts (enda källan).
    rating: ratingFor("akersberga"),
    reviewCount: reviewCountFor("akersberga"),
    googleRating: salonReviewStats["akersberga"].google.rating,
    googleReviewCount: salonReviewStats["akersberga"].google.count,
    openingHours: akersbergaHours,
    servicesOffered: ["herrklippning", "har-skagg", "taper-fade", "fade", "barnklippning", "drop-in"],
    priceRange: "$$",
    featuredLabel: "Åkersberga",
  },
  {
    slug: "arninge",
    name: "Tailor's Barber Arninge",
    shortName: "Arninge Ica Maxi",
    url: "/barberare-stockholm-arninge",
    bokaDirektUrl: "https://www.bokadirekt.se/places/tailors-barber-arninge-ica-maxi-huset--61598",
    phone: "+468371156",
    phoneDisplay: "08-371 156",
    email: "info@tailorsbarber.com",
    address: "Kundvägen 1D",
    postal: "187 66",
    city: "Täby",
    mapsUrl: "https://www.google.com/maps/place/Tailors+Barber+Arninge/@59.4624665,18.1277116,17z/data=!3m1!4b1!4m6!3m5!1s0x465f9b0fd0f68e71:0xfa8c35ab5f2a19e3!8m2!3d59.4624665!4d18.1302865!16s%2Fg%2F11x25kd8xz",
    lat: 59.4625,
    lng: 18.1303,
    description:
      "Vår salong i ICA Maxi Arninge. Modern, ljus och lättillgänglig — perfekt för dig som vill kombinera klippning med shopping eller ärenden.",
    image: arninge,
    imageThumb: arningeThumb,
    // Omdömestal: se src/data/reviewStats.ts (enda källan).
    rating: ratingFor("arninge"),
    reviewCount: reviewCountFor("arninge"),
    googleRating: salonReviewStats["arninge"].google.rating,
    googleReviewCount: salonReviewStats["arninge"].google.count,
    openingHours: arningeHours,
    servicesOffered: ["herrklippning", "har-skagg", "taper-fade", "fade", "barnklippning", "drop-in"],
    priceRange: "$$",
    featuredLabel: "Arninge",
  },
];

export const salonBySlug = Object.fromEntries(salons.map((s) => [s.slug, s])) as Record<
  Salon["slug"],
  Salon
>;

export const salonByUrl = Object.fromEntries(salons.map((s) => [s.url, s])) as Record<
  string,
  Salon
>;


